import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface DeleteStaffCompetenceModalProps {
  competenceName: string;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeleteStaffCompetenceModal = ({
  competenceName,
  onConfirm,
  onClose
}: DeleteStaffCompetenceModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('config-sc-delete-title')}
      message={t('config-sc-delete-message', { name: competenceName })}
      warning={t('config-sc-delete-warning')}
      cancelLabel={t('config-delete-template-cancel')}
      confirmLabel={t('config-delete-template-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
